import { validateString } from 'avilatek-utils';
import { ExcelDocument } from '../../models';

export function validateExcelDocument({
  tableRow,
  name,
  file,
}: Partial<ExcelDocument>): string {
  if (!validateString(name) && name !== '') {
    return 'El nombre del archvio es inválido';
  }
  if (!tableRow || tableRow.length === 0) {
    return 'El archivo debe contener al menos una fila';
  }
  if (!file) {
    return 'El documento debe contener un archivo válido';
  }
  return '';
}
